export default __webpack_public_path__ + "static/scribeforce-10fbf3243d04b536d5a291b96b464260.png";